module.exports = __webpack_public_path__ + "img/rideable.69c67506.svg";